export default __webpack_public_path__ + "static/media/despair.1897788d.mp3";